import { render } from "./EditDeliveryDetails.vue?vue&type=template&id=69283d4b&scoped=true"
import script from "./EditDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./EditDeliveryDetails.vue?vue&type=script&lang=js"

import "./EditDeliveryDetails.vue?vue&type=style&index=0&id=69283d4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69283d4b"]])

export default __exports__